import React, { Component } from "react";

class Shipping extends Component {
  componentWillMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="shipping">
        <div className="shipping__shippingContainer">
          <i className="fas fa-shipping-fast" />
          <h3>Shipping Times</h3>
          <ul>
            <li>
              <div>
                {/* <i className="fas fa-shipping-fast" /> */}
                <p>
                  In our experience, it will take an average of 2 to 3 weeks for
                  you to receive your package. Please note that we have a 30 day
                  shipping guarantee.
                </p>
              </div>
            </li>
            <li>
              <div>
                {/* <i className="fas fa-certificate" /> */}
                <p>
                  If your order does not arrive within 30 days from the date it
                  was shipped, we will offer you a re-shipment at no additional
                  cost.
                </p>
              </div>
            </li>
            <li>
              <div>
                {/* <i className="fas fa-calendar-times" /> */}
                <p>
                  Please be aware that these are average processing and shipping
                  times. Mailing delays can occur beyond our control.
                </p>
              </div>
            </li>
          </ul>
          <h3>Shipping to International address</h3>
          <ul>
            <li>
              <div>
                <p>
                  Once we have all of your order information, your order will be
                  forwarded to processing. The in-house processing time and the
                  shipping time will vary depending on the source country of
                  your medication. <br /> In our experience, it will take an
                  average of 4 to 6 weeks for you to receive your package.
                </p>
              </div>
            </li>
            <li>
              <div>
                <p>
                  If your order does not arrive within 6 weeks from the date it
                  was shipped, we will offer you a re-shipment at no additional
                  cost.
                </p>
              </div>
            </li>
            <li>
              <div>
                <p>
                  Please be aware that these are average processing and shipping
                  times. Mailing delays can occur beyond our control.
                </p>
              </div>
            </li>
          </ul>
          <img src="./assets/2.jpg" alt="" />
        </div>
      </div>
    );
  }
}

export default Shipping;



// WEBPACK FOOTER //
// ./src/components/Shipping/Shipping.js